module.exports = __webpack_public_path__ + "img/wp-existing-habit-card2.a68ba46b.jpg";